// extracted by mini-css-extract-plugin
module.exports = {"open-app":"_2crSa","openApp":"_2crSa","loader":"_21VPJ","text":"_2EUfz","empty-pic":"VPLeS","emptyPic":"VPLeS"};